"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledTheming = _interopRequireDefault(require("styled-theming"));

var _Constant = require("../Dashboard/Constant");

var _Constant2 = require("../Constant");

var _VisuallyHidden = _interopRequireDefault(require("../VisuallyHidden"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n  font-family: ", ";\n  /* The underline color should match the text color in all states */\n  text-decoration-color: currentcolor;\n  text-decoration-line: ", ";\n\n  /* Hover styles are applied only when the user's primary input mechanism can hover over the component */\n  @media (hover: hover) { \n    &:hover {\n      color: ", ";\n      /* Added for when the link isn't initially underlined */\n      text-decoration-line: underline;\n    }\n  }\n\n  &[data-focus-visible-added]:focus {\n    ", "\n    color: ", ";\n    /* Added for when the link isn't initially underlined */\n    text-decoration-line: underline;\n    outline-offset: 2px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var baseFlowStyles = (0, _styledTheming.default)('flow', {
  dashboard: _Constant.Color.BLACK_SOUL,
  onboarding: _Constant2.Color.DARK_GREY_2
});
var stateColors = (0, _styledTheming.default)('mode', {
  caliber: _Constant2.Color.DARK_GREY_2,
  homepoint: _Constant2.Color.DARK_GREY_2,
  figure: _Constant2.Color.FOCUS_B,
  pella: _Constant2.Color.FOCUS_B,
  petersendean: _Constant2.Color.FOCUS_B
});
var focusStyles = (0, _styledTheming.default)('mode', {
  caliber: "outline: 1px solid ".concat(_Constant2.Color.CALIBER_PASTEL_BLUE, ";"),
  homepoint: "outline: 1px solid ".concat(_Constant2.Color.HOMEPOINT_LIGHT_BLUE, ";"),
  figure: "outline: 1px solid ".concat(_Constant2.Color.FOCUS_B, ";"),
  pella: "outline: 1px solid ".concat(_Constant2.Color.FOCUS_B, ";"),
  petersendean: "outline: 1px solid ".concat(_Constant2.Color.FOCUS_B, ";")
});

var PureBody = _styledComponents.default.a(_templateObject(), function (props) {
  return props.$textColor ? props.$textColor : baseFlowStyles;
}, _Constant2.Font.PRIMARY_FONT, function (props) {
  return props.$isUnderlined ? 'underline' : 'none';
}, stateColors, focusStyles, stateColors);
/**
 * Transient props are used to indicate props used purely for styling. https://medium.com/@probablyup/introducing-transient-props-f35fd5203e0c
 * This resolves the invalid prop on DOM element warnings when using the React Router Link.
 */


var AnchorBase = function AnchorBase(_ref) {
  var children = _ref.children,
      className = _ref.className,
      isUnderlined = _ref.isUnderlined,
      semanticElement = _ref.semanticElement,
      textColor = _ref.textColor,
      props = (0, _objectWithoutProperties2.default)(_ref, ["children", "className", "isUnderlined", "semanticElement", "textColor"]);
  var target = props.target;
  return /*#__PURE__*/_react.default.createElement(PureBody, (0, _extends2.default)({
    as: semanticElement,
    className: className,
    $isUnderlined: isUnderlined,
    $textColor: textColor,
    target: target
  }, props), children, target === '_blank' && /*#__PURE__*/_react.default.createElement(_VisuallyHidden.default, null, " Opens in a new tab"));
};

AnchorBase.propTypes = {
  children: _propTypes.default.node,
  className: _propTypes.default.string,

  /**
   * Inline links should always be underlined to support accessibility.
   * If a link is not near other text, `isUnderlined` can be used to remove the underline for the inactive state.
   */
  isUnderlined: _propTypes.default.bool,

  /** Maintains link styles while rendering a different HTML element. Accepts a string representation of an html element or a component function */
  semanticElement: _propTypes.default.any,

  /** Customizes the text and underline color */
  textColor: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.string]),
  target: _propTypes.default.string
};
AnchorBase.defaultProps = {
  children: null,
  className: '',
  isUnderlined: true,
  semanticElement: 'a',
  textColor: baseFlowStyles,
  target: ''
};
var _default = AnchorBase;
exports.default = _default;